import { promiseApiAction } from 'actions/application'
import * as vehicles from 'services/vehicles'
import * as ptoTemplates from 'services/ptoTemplates'
import { powerTakeOffSchema } from 'schemas/powerTakeOff'
import { ptoTemplateSchema } from 'schemas/ptoTemplates'
import { PTO_TEMPLATES } from 'utils/constants'
import { createAction } from './utils'

export const POWER_TAKE_OFF_RECEIVED = 'POWER_TAKE_OFF_RECEIVED'
export const getPowerTakeOff = (serialNumber) =>
  promiseApiAction({
    asyncFn: vehicles.getPowerTakeOff,
    args: { serialNumber },
    successActionType: POWER_TAKE_OFF_RECEIVED,
    id: serialNumber,
    schema: powerTakeOffSchema,
  })

export const CLEAR_POWER_TAKE_OFF = 'CLEAR_POWER_TAKE_OFF'
export const clearPowerTakeOff = createAction(CLEAR_POWER_TAKE_OFF)

export const CLEAR_SAVE_POWER_TAKE_OFF_ERROR = 'CLEAR_SAVE_POWER_TAKE_OFF_ERROR'
export const clearSavePowerTakeOffError = createAction(
  CLEAR_SAVE_POWER_TAKE_OFF_ERROR
)

export const PTO_TEMPLATES_RECEIVED = 'PTO_TEMPLATES_RECEIVED'
export const getPtoTemplatesMeta = (serialNumber) =>
  promiseApiAction({
    asyncFn: vehicles.getPtoTemplatesMeta,
    args: { serialNumber },
    successActionType: PTO_TEMPLATES_RECEIVED,
    id: serialNumber,
    schema: ptoTemplateSchema,
  })

export const getPtoTemplates = () =>
  promiseApiAction({
    asyncFn: vehicles.getPtoTemplates,
    successActionType: PTO_TEMPLATES_RECEIVED,
    id: PTO_TEMPLATES,
    schema: ptoTemplateSchema,
  })

export const PTO_TEMPLATE_BY_ID_RECEIVED = 'PTO_TEMPLATE_BY_ID_RECEIVED'
export const getPtoTemplateById = (templateId) =>
  promiseApiAction({
    asyncFn: vehicles.getPtoTemplateById,
    args: { templateId },
    successActionType: PTO_TEMPLATE_BY_ID_RECEIVED,
    id: templateId,
    schema: powerTakeOffSchema,
  })

export const PTO_TEMPLATE_SAVE = 'PTO_TEMPLATE_SAVE'
export const PTO_TEMPLATE_SAVE_SUCCESS = 'PTO_TEMPLATE_SAVE_SUCCESS'
export const PTO_TEMPLATE_SAVE_FAILED = 'PTO_TEMPLATE_SAVE_FAILED'
export const savePtoTemplate = (
  { templateId, name, description, notes, fragments },
  callback
) =>
  promiseApiAction({
    asyncFn: ptoTemplates.savePtoTemplate,
    args: {
      notes,
      description,
      name,
      fragments: Object.values(fragments),
      templateId,
    },
    successActionType: PTO_TEMPLATE_SAVE_SUCCESS,
    failureActionType: PTO_TEMPLATE_SAVE_FAILED,
    id: templateId,
    resolve: callback,
    reject: callback,
  })

export const getVehiclePtoTemplateById = (templateId, serialNumber) =>
  promiseApiAction({
    asyncFn: vehicles.getVehiclePtoTemplateById,
    args: { templateId, serialNumber },
    successActionType: PTO_TEMPLATE_BY_ID_RECEIVED,
    id: templateId,
    schema: powerTakeOffSchema,
  })

export const CREATE_PTO_TEMPLATE = 'CREATE_PTO_TEMPLATE'
export const createPtoTemplate = createAction(CREATE_PTO_TEMPLATE, [
  'templatePayload',
])

export const CREATE_PTO_TEMPLATE_SUCCESS = 'CREATE_PTO_TEMPLATE_SUCCESS'
export const CREATE_PTO_TEMPLATE_FAIL = 'CREATE_PTO_TEMPLATE_FAIL'
export const postCreatePtoTemplate = (
  serialNumber,
  {
    notes,
    templateName,
    templateDescription,
    domainList,
    isTemplateRounded,
    callback,
  }
) =>
  promiseApiAction({
    asyncFn: vehicles.createPtoTemplate,
    args: {
      serialNumber,
      notes,
      templateName,
      templateDescription,
      domainList,
      isTemplateRounded,
    },
    successActionType: CREATE_PTO_TEMPLATE_SUCCESS,
    failureActionType: CREATE_PTO_TEMPLATE_FAIL,
    resolve: callback,
    reject: callback,
    schema: powerTakeOffSchema,
  })

export const UPDATE_TEMPLATE_FRAGMENTS = 'UPDATE_TEMPLATE_FRAGMENTS'
export const updateTemplateFragments = createAction(UPDATE_TEMPLATE_FRAGMENTS, [
  'notes',
  'templateId',
  'callback',
])

export const UPDATE_FRAGMENT_VALUE = 'UPDATE_FRAGMENT_VALUE'
export const updateFragmentValue = createAction(UPDATE_FRAGMENT_VALUE, [
  'id',
  'value',
])

export const UPDATE_FRAGMENTS = 'UPDATE_FRAGMENTS'
export const updateFragments = createAction(UPDATE_FRAGMENTS, [
  'notes',
  'callback',
])

export const UPDATE_FRAGMENTS_SUCCESS = 'UPDATE_FRAGMENTS_SUCCESS'
export const UPDATE_FRAGMENTS_FAIL = 'UPDATE_FRAGMENTS_FAIL'
export const postUpdateFragments = (serialNumber, fragments, notes, callback) =>
  promiseApiAction({
    asyncFn: vehicles.updateFragments,
    args: { serialNumber, fragments, notes },
    successActionType: UPDATE_FRAGMENTS_SUCCESS,
    failureActionType: UPDATE_FRAGMENTS_FAIL,
    resolve: callback,
    reject: callback,
    schema: powerTakeOffSchema,
  })

export const RESET_FRAGMENTS = 'RESET_FRAGMENTS'
export const resetFragments = createAction(RESET_FRAGMENTS, ['fragmentIds'])

export const SELECT_GROUP_PTO_CONFIG = 'SELECT_GROUP_PTO_CONFIG'
export const selectGroupPtoConfig = createAction(SELECT_GROUP_PTO_CONFIG, [
  'config',
])

export const RESET_GROUP_PTO_CONFIG = 'RESET_GROUP_PTO_CONFIG'
export const resetGroupPtoConfig = createAction(RESET_GROUP_PTO_CONFIG)

export const UPDATE_PTO_TEMPLATE = 'UPDATE_PTO_TEMPLATE'
export const updatePtoTemplate = createAction(UPDATE_PTO_TEMPLATE, ['template'])

export const UPDATE_PTO_TEMPLATE_FRAGMENT_VALUE =
  'UPDATE_PTO_TEMPLATE_FRAGMENT_VALUE'
export const updatePtoTemplateFragmentValue = createAction(
  UPDATE_PTO_TEMPLATE_FRAGMENT_VALUE,
  ['templateId', 'fragmentId', 'value']
)

export const UPDATE_PTO_TEMPLATE_FRAGMENT_FROM_DEFAULT =
  'UPDATE_PTO_TEMPLATE_FRAGMENT_FROM_DEFAULT'
export const updatePtoTemplateFragmentFromDefault = createAction(
  UPDATE_PTO_TEMPLATE_FRAGMENT_FROM_DEFAULT,
  ['templateId', 'refNo', 'newValue']
)
